<script setup lang="ts">
import InfiniteLoadingTrigger from '@/sharedComponents/InfiniteLoadingTrigger.vue'
import LoadingSkeleton from '@/sharedComponents/LoadingSkeleton.vue'
import CaseCard from './CaseCard.vue'
import type { PaginatedCase } from './types'
import { CASES_PAGE_SIZE } from './useCaseStore'

defineProps<{
  workspaceId: string
  cases: PaginatedCase[]
  loading?: boolean
  hasMoreCases?: boolean
}>()

const emit = defineEmits<{
  rename: [id: string, name: string]
  loadMore: []
}>()
</script>

<template>
  <nav
    class="contents"
    aria-label="Dashboard"
  >
    <!-- Loading Skeletons-->
    <template v-if="loading">
      <div class="grid w-full grid-cols-1 gap-1">
        <LoadingSkeleton
          v-for="n in Math.max(cases.length, CASES_PAGE_SIZE)"
          :key="n"
          :status="true"
          class="h-[76px] w-full !rounded-corner-20"
        />
      </div>
    </template>
    <div
      v-else
      class="grid w-full grid-cols-1 gap-1"
    >
      <CaseCard
        v-for="targetCase in cases"
        :key="targetCase.id"
        :target-case="targetCase"
        :workspace-id="workspaceId"
        @rename="emit('rename', targetCase.id, $event)"
      />
      <InfiniteLoadingTrigger
        v-if="hasMoreCases"
        class="size-full"
        :loading="loading"
        @trigger="emit('loadMore')"
      >
        <template #default>
          <div class="flex w-full flex-col gap-1">
            <LoadingSkeleton
              v-for="n in CASES_PAGE_SIZE"
              :key="n"
              :status="true"
              class="h-[76px] w-full !rounded-corner-20"
            />
          </div>
        </template>
      </InfiniteLoadingTrigger>
    </div>
  </nav>
</template>
